export const testId = 'DescriptionBox';

interface Props {
    key: number | null | undefined;
    content: string | null | undefined;
    makeImageUrl?: string | null;
    onClick?: () => void;
    selected?: boolean;
    vehicleUnknown?: boolean;
}

function DescriptionBox({
    content,
    makeImageUrl,
    onClick,
    selected,
    vehicleUnknown,
}: Props): JSX.Element {
    const generalClassName = `italic text-xs border rounded-[10px]`;
    const className = `${generalClassName} ${
        selected
            ? `border border-primary text-center p-2 m-2
       cursor-pointer bg-white text-black`
            : `border border-secondary text-center p-2 m-2 ${
                  vehicleUnknown ? 'cursor-pointer' : ''
              }`
    }`.trim();

    const DEFAULT_MAKE_IMAGE =
        'https://www.shutterstock.com/image-vector/default-ui-image-placeholder-wireframes-600nw-1037719192.jpg';

    const imageUrl = makeImageUrl || DEFAULT_MAKE_IMAGE;

    return (
        <div className={className} onClick={onClick}>
            <div className='flex items-center gap-2'>
                <img
                    src={imageUrl}
                    alt='Vehicle make'
                    className='w-20 h-20 object-contain'
                />
                <span>{content}</span>
            </div>
        </div>
    );
}

export { DescriptionBox };
